import React from 'react'
import { Modal } from '../../../UI/Modal'
import { UnmatchedDoorsTable } from '../../../DataExpansionComponents/UnmatchedDoors/UnmatchedDoorsTable'
import { CreateDoorProxyModal } from '../../../Modals/CompanyModal/CreateDoorProxyModal'
import { IContactCompany } from 'models/contact_companies'
import { FilterIdentifier } from 'models/saved_view'
import { SubCategoryInfo } from '../../../Cards/DoorSections/types'

interface UnmatchedDoorsModalProps {
  show: boolean
  onHide: () => void
  forChainProxyId: number
  chainData: {
    id: number
    name: string
    domain?: string
  }
  subCategory: SubCategoryInfo
  companyName?: string
}

export function UnmatchedDoorsModal({
  show,
  onHide,
  forChainProxyId,
  chainData,
  subCategory,
  companyName,
}: UnmatchedDoorsModalProps) {
  // Create chainProxy object for CreateDoorProxyModal and UnmatchedDoorsTable
  const chainProxy: IContactCompany = {
    id: forChainProxyId,
    domain: chainData.domain || '',
    name: chainData.name || subCategory.name,
    sub_category: subCategory,
  } as IContactCompany

  const unmatchedTableKey = `${subCategory.slug}-unmatched-modal-${forChainProxyId}`

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="flex items-center justify-between w-full">
            <span>{companyName || chainData.name} Doors</span>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="flex justify-end mb-3">
          <CreateDoorProxyModal
            chainProxy={chainProxy}
            unmatchedTableKey={unmatchedTableKey}
          />
        </div>
        <div className="max-h-[540px] overflow-auto">
          <UnmatchedDoorsTable
            tableKey={unmatchedTableKey}
            filterIdentifierModifier={
              forChainProxyId.toString() as FilterIdentifier
            }
            chainProxy={chainProxy}
          />
        </div>
      </Modal.Body>
    </Modal>
  )
}
